// Деплой викидає старі хеш-чанки: вкладка (чи PWA-іконка на iOS) відкрита до релізу
// тримає старий index.html і падає на import() лінивого маршруту. Формулювання різниться
// між браузерами: Chrome/Firefox «Failed to fetch dynamically imported module», Safari
// «Importing a module script failed». Той самий симптом дає обрив мобільної мережі під
// час import — лікується тим самим перезавантаженням.
const STALE_CHUNK = /failed to fetch dynamically imported module|importing a module script failed/i

export const isStaleChunkError = (error: unknown): boolean => error instanceof Error && STALE_CHUNK.test(error.message)

// Прапорець живе рівно одну вкладку-сесію: реально зламаний деплой (чанка нема й після
// оновлення) не зациклює релоад, а другий провал доїжджає в Sentry як справжня подія.
const RELOADED_KEY = 'stale-chunk-reloaded'

// Повертає true, якщо перезавантаження запущено — консумер тоді не малює екран помилки.
// index.html віддається no-store (web-server), тож свіжа сторінка приходить із чинними хешами.
const willReloadStaleChunk = (error: unknown): boolean => {
	if (!isStaleChunkError(error)) return false

	try {
		if (sessionStorage.getItem(RELOADED_KEY) !== null) return false
		sessionStorage.setItem(RELOADED_KEY, '1')
	} catch {
		// Storage недоступний (приватний режим, заблоковані cookie) — без прапорця релоад
		// може зациклитись, тож краще показати екран помилки.
		return false
	}

	location.reload()

	return true
}

export default willReloadStaleChunk
